'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_OystrAdminPage$() {
}
export { $c_Lpresto_OystrAdminPage$ as $c_Lpresto_OystrAdminPage$ };
$p = $c_Lpresto_OystrAdminPage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_OystrAdminPage$;
/** @constructor */
function $h_Lpresto_OystrAdminPage$() {
}
export { $h_Lpresto_OystrAdminPage$ as $h_Lpresto_OystrAdminPage$ };
$h_Lpresto_OystrAdminPage$.prototype = $p;
$p.dw = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$();
});
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return (-1656770985);
});
$p.l = (function() {
  return "OystrAdminPage";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "OystrAdminPage";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lpresto_OystrAdminPage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_OystrAdminPage$, "presto.OystrAdminPage$", ({
  MG: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_OystrAdminPage$ as $d_Lpresto_OystrAdminPage$ };
var $n_Lpresto_OystrAdminPage$;
function $m_Lpresto_OystrAdminPage$() {
  if ((!$n_Lpresto_OystrAdminPage$)) {
    $n_Lpresto_OystrAdminPage$ = new $c_Lpresto_OystrAdminPage$();
  }
  return $n_Lpresto_OystrAdminPage$;
}
export { $m_Lpresto_OystrAdminPage$ as $m_Lpresto_OystrAdminPage$ };
//# sourceMappingURL=presto.-Oystr-Admin-Page$.js.map
